import { FC } from 'react'

import { RequestConfirmationBottomSheetProviderBR } from 'contexts/bottomsheet-context/RequestConfirmationBottomSheetContextBR'
import { RequestConfirmationBottomSheetProviderUS } from 'contexts/bottomsheet-context/RequestConfirmationBottomSheetContextUS'

import { ProductDetails } from './ProductDetails'

const ProductDetailsProviders: FC = () => (
  <RequestConfirmationBottomSheetProviderBR>
    <RequestConfirmationBottomSheetProviderUS>
      <ProductDetails />
    </RequestConfirmationBottomSheetProviderUS>
  </RequestConfirmationBottomSheetProviderBR>
)

export { ProductDetailsProviders }
